import {
    Routes, Route
} from "react-router-dom";

import ProductDetails from '../pages/HomeAndProducts/ProductDetails';
import Locations from '../pages/CommonPages/Locations';
import PageDefault from '../pages/CommonPages/PageDefault';
import TabCart from '../pages/CartAndPayment/TabCart';
import ViewUser from '../pages/Customer/TabUser';
import UserSettings from '../pages/Customer/Preferences/UserSettings';
import LoyaltyScreen from '../pages/Customer/Loyalty/LoyaltyScreen';
import HomeClearCart from '../pages/HomeAndProducts/HomeClearCart';
import UserLoginLinkError from '../pages/Customer/Login/UserLoginLinkError';
import Order from '../pages/Orders/Order';
import PayWasKo from '../pages/CartAndPayment/PayWasKo';
import PayWasOk from '../pages/CartAndPayment/PayWasOk';
import RecommendFriends from '../pages/Customer/RecommendFriends';
import UserInvoices from '../pages/Customer/Invoices/UserInvoices';
import CustomerAddresses from '../pages/Customer/Address/CustomerAddresses';
import LocalDataStore from '../common/LocalDataStore';
import TabDelivery from '../pages/CartDelivery/TabCartDelivery';
import DeliverOrders from '../pages/Customer/DeliveryOrders/DeliveryOrders';
import CartDeliverPayWasKo from '../pages/CartDelivery/CartDeliverPayWasKo';
import CartDeliverPayWasOk from '../pages/CartDelivery/CartDeliverPayWasOk';
import UserOrders from '../pages/Customer/TabOrders';
import UserLoginEmulate from '../pages/Customer/Login/UserLoginEmulate'
import TabHome from '../pages/HomeAndProducts/TabHome';
import TabOptions from '../pages/Options/TabOptions';
import TabRecipes from "../pages/Tools/TabRecipes";
import UserLoginEnd from "../pages/Customer/Login/UserLoginEnd";
import UserLoginLink from "../pages/Customer/Login/UserLoginLink";

function empty(): any {
    return <></>
}
export function AppRoute() {
    const locationCode = LocalDataStore.locationGet()
    return (
        <Routes>
            <Route path="/" element={<TabHome />} />
            <Route path="/home" element={<TabHome />} />
            <Route path="/options" element={<TabOptions />} />
            <Route path="/page" element={<PageDefault />} />
            <Route path="/page/address" element={<Locations />} />
            <Route path="/page/:pageCode" element={<PageDefault />} />
            <Route path="/user" element={<ViewUser />} />
            <Route path="/user/invoices" element={<UserInvoices />} />
            <Route path="/user/deliver_orders" element={<DeliverOrders />} />
            <Route path="/user_orders" element={<UserOrders />} />
            <Route path="/user/settings" element={<UserSettings />} />
            <Route path="/user/loyalty" element={<LoyaltyScreen />} />
            <Route path="/user/address" element={<CustomerAddresses />} />
            <Route path="/user_login" element={<UserLoginEnd />} />
            <Route path="/user_login_link" element={<UserLoginLink />} />
            <Route path="/user_login_error" element={<UserLoginLinkError />} />
            <Route path="/user/recommend_friends" element={<RecommendFriends />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/user/locations" element={<Locations />} />
            <Route path="/cart" element={locationCode === 'ONLINE' ? <TabDelivery /> : <TabCart />} />
            <Route path="/cart/clear" element={<HomeClearCart />} />
            <Route path="/order/:orderId" element={<Order />} />
            <Route path="/pko" element={<PayWasKo />} />
            <Route path="/pok" element={<PayWasOk />} />
            <Route path="/pdok" element={<CartDeliverPayWasOk />} />
            <Route path="/pdok" element={<CartDeliverPayWasKo />} />
            <Route path="/:locationCode" element={empty()} />
            <Route path="/:locationCode/cats/:cat" element={empty()} />
            <Route path="/:locationCode/product/:productCode" element={<ProductDetails />} />
            <Route path="/login_emulate/:customerId" element={<UserLoginEmulate />} />
            <Route path="/recipes" element={<TabRecipes />} />
        </Routes>
    )
}
